import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            language: "Language",
            title: "Plataforma DTS",
            username: "Username",
            password: "Password",
            login: "Login",
            register: "Register",
            back: "Back to Landing",
            version: "Version 3.0.0",
        },
    },
    es: {
        translation: {
            language: "Idioma",
            title: "Plataforma DTS",
            username: "Usuario",
            password: "Contraseña",
            login: "Ingresar",
            register: "Registrarse",
            back: "Volver a Landing",
            version: "Versión 3.0.0",
        },
    },
};

i18n
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .init({
        resources,
        lng: "en", // Set default language
        fallbackLng: "en", // Fallback if the selected language isn't available
        interpolation: {
            escapeValue: false, // React already escapes values
        },
    });

export default i18n;
